import React from "react";
import { Link } from "react-router-dom";
import Button from "../Button";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ServiceCard = ({
  white,
  title,
  text,
  image,
  servicesUrl,
  wrapperLink,
  wrapperLinkUniversa
}) => {
  const cardInner = () => {
    return (
      <div className="d-flex flex-column h-100 align-items-start text-left">
        {/* Bloque superior: Imagen, Título y Descripción */}
        <div className="w-100">
          <LazyLoadImage src={image} alt="icon" loading="lazy" effect="blur" />
          <hr className="home-slider_info__line" style={{ marginLeft: "0px" }} />
          <h4 className="mb-3">{title}</h4>
          {text && <p className="mb-3">{text}</p>}
        </div>

        {/* Bloque inferior: Se empuja al fondo con mt-auto si existen botones */}
        {servicesUrl && servicesUrl.length > 0 && (
          <div className="w-100 mt-auto pt-3 d-flex flex-column gap-2">
            {servicesUrl.map(item => (
              <Button key={item.title} type="white-outline" url={item.url}>
                {item.title}
              </Button>
            ))}
          </div>
        )}
      </div>
    );
  };

  const getCardClass = () =>
    `w-100 h-100 d-block text-decoration-none ${
      white ? "container-boxes_light" : "container-boxes_dark"
    }`;

  if (wrapperLink) {
    return (
      <Link to="/cartilla-medica" className={getCardClass()}>
        <article className="h-100">{cardInner()}</article>
      </Link>
    );
  }

  if (wrapperLinkUniversa) {
    return (
      <Link to="/universal-assistance" className={getCardClass()}>
        <article className="h-100">{cardInner()}</article>
      </Link>
    );
  }

  return (
    <article className={getCardClass()}>{cardInner()}</article>
  );
};

export default ServiceCard;